import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthStatusContext } from '../../context/firebase-context'
import StatusScreen from '../StatusScreen/StatusScreen'

/**
 * Shown when Firebase has a session but the account behind it failed to load
 * (`hydrateFailed`). Redirecting instead is what looped `/projects/new` ↔ `/`.
 * `returnTo` is where the brand login sends the visitor after signing out.
 */
const AuthFailureScreen = ({ returnTo }) => {
  const navigate = useNavigate()
  const { retryHydrate } = useContext(AuthStatusContext)

  const signOut = () => {
    navigate(returnTo ? `/logout?r=${encodeURIComponent(returnTo)}` : '/logout')
  }

  return (
    <StatusScreen
      title='Couldn’t load your account'
      description='We couldn’t reach our servers. Check your connection and try again.'
      primaryLabel='Try again'
      onPrimary={() => retryHydrate()}
      secondaryLabel='Sign out'
      onSecondary={signOut}
    />
  )
}

export default AuthFailureScreen
